import React from "react";
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Stack,
} from "@mui/material"

const TeamManagementSkeleton = ({
  showButton = false,
  isGroupsTab = false,
}) => {
  const skeletonRows = Array.from({ length: 9 }, (_, index) => index)

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          gap: 2,
        }}
      >
        <Skeleton variant="rectangular" width={280} height={40} sx={{ borderRadius: "8px", marginTop: "10px" }} />
        {showButton && (
          <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: "8px", width: "144px" }} />
        )}
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: "none", border: "none" }}>
        <Table>
          <TableHead>
            <TableRow >
              <TableCell sx={{ fontWeight: 600, color: "#666" }}>
                <Skeleton variant="text" width={60} height={20} />
              </TableCell>
              {!isGroupsTab && (
                <TableCell sx={{ fontWeight: 600, color: "#666" }}>
                  <Skeleton variant="text" width={50} height={20} />
                </TableCell>
              )}
              <TableCell sx={{ fontWeight: 600, color: "#666" }}>
                <Skeleton variant="text" width={60} height={20} />
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#666" }}>
                <Skeleton variant="text" width={40} height={20} />
              </TableCell>
              {!isGroupsTab && (
                <TableCell sx={{ fontWeight: 600, color: "#666" }}>
                  <Skeleton variant="text" width={50} height={20} />
                </TableCell>
              )}
              <TableCell sx={{ width: 50 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {skeletonRows.map((index) => (
              <TableRow key={index} sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Skeleton variant="circular" width={40} height={40} sx={{ flexShrink: 0 }} />
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      <Skeleton variant="text" width={120} height={20} sx={{ fontSize: "1rem" }} />
                      {isGroupsTab && (
                        <Skeleton variant="text" width={80} height={20} sx={{ fontSize: "1rem" }} />
                      )}
                    </Box>
                  </Box>
                </TableCell>
                {!isGroupsTab && (
                  <TableCell>
                    <Skeleton variant="text" width={200} height={20} sx={{ fontSize: "1rem" }} />
                  </TableCell>
                )}

                <TableCell>
                  <Stack direction="row" spacing={-0.5} sx={{ alignItems: "center" }}>
                    {Array.from({ length: 4 }, (_, i) => (
                      <Skeleton
                        key={i}
                        variant="circular"
                        width={40}
                        height={40}
                        sx={{
                          border: "2px solid white",
                          zIndex: 4 - i,
                        }}
                      />
                    ))}
                  </Stack>
                </TableCell>
                {!isGroupsTab && (
                  <TableCell>
                    <Skeleton variant="text" width={80} height={20} sx={{ fontSize: "1rem" }} />
                  </TableCell>
                )}

                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Skeleton variant="circular" width={8} height={8} />
                    <Skeleton variant="text" width={60} height={20} sx={{ fontSize: "1rem" }} />
                    <Skeleton variant="rectangular" width={16} height={16} sx={{ borderRadius: "2px" }} />
                  </Box>
                </TableCell>

                <TableCell>
                  <Skeleton variant="rectangular" width={24} height={24} sx={{ borderRadius: "4px" }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default TeamManagementSkeleton
